import React from "react"

import {
  useStyle 
} from "@/classify"
import defaultClasses from "./errorMessage.module.css"

// eslint-disable-next-line react/display-name
const ErrorMessage = React.forwardRef((props, ref) => {
  const {
    children 
  } = props

  const classes = useStyle(defaultClasses, props.classes)

  return (
    <div className={classes.root} ref={ref} data-cy='ErrorMessage-root'>
      <span
        className={classes.errorMessage}
        data-cy='ErrorMessage-errorMessage'
      >
        {children}
      </span>
    </div>
  )
})

export default ErrorMessage
